import React, { useState, useContext } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

// import NowPlayingContext from './contexts/now-playing/now-playing.context';

import Header from './components/header/Header';
import Player from './components/player/Player';
import Menu from './components/menu/Menu';
import Footer from './components/footer/Footer';
import PrivateRoute from './components/private-route/PrivateRoute';

import HomePage from './pages/home-page/HomePage';
import PodcastPage from './pages/podcast/PodcastPage';
import HistoryPage from './pages/history-page/HistoryPage';
import CategoryPage from './pages/category-page/CategoryPage';
import LogInSignUpPage from './pages/logIn-signUp-page/LogInSignUpPage';
import FavoritesPage from './pages/favorites-page/FavoritesPage';

import { NowPlayingContext } from './contexts/now-playing.context';
import PlayerProvider from './contexts/player.context';

import './App.styles.scss';

function App({ location }) {
  const { nowPlaying } = useContext(NowPlayingContext);
  const [open, setOpen] = useState(false);

  const isSignInRoute =
    location.pathname === '/signin' || location.pathname === '/signup';

  return (
    <div className="App">
      <Header open={open} setOpen={setOpen} isSignInRoute={isSignInRoute} />
      <Route path="/signin" component={LogInSignUpPage} />
      <Route path="/signup" component={LogInSignUpPage} />
      {!isSignInRoute && (
        <div className="py">
          <main className="main container">
            <Menu open={open} setOpen={setOpen} />
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route path="/podcast/:podcastId" component={PodcastPage} />
              <Route exact path="/history" component={HistoryPage} />
              <PrivateRoute exact path="/favorites" component={FavoritesPage} />
              <Route path="/category/:categoryId" component={CategoryPage} />
            </Switch>
          </main>
        </div>
      )}
      {nowPlaying && (
        <PlayerProvider>
          <Player />
        </PlayerProvider>
      )}
    </div>
  );
}

export default withRouter(App);
